import { useEffect } from 'react';

const usePostMessage = (data: any) => {
  useEffect(() => {
    window.parent.postMessage(data, '*');
  }, [data]);
};

export default usePostMessage;
